export const environment = {
    production: false,
    rootApiUrl: 'https://dev-core-api.portal.ai',
  };
  